<div class="search-filter-container">
  <div class="search-input-wrapper" [ngClass]="{ 'full-width': !showFilter }">
    <ion-icon name="search-outline" class="search-icon" />
    <input
      #searchBarInline
      class="search-input"
      [placeholder]="placeholder | translate"
      [(ngModel)]="search"
      (input)="searchChange.emit(search)"
      type="text"
    />
    @if ((search || '').trim().length > 0) {
    <ion-icon
      name="close-circle"
      class="clear-icon"
      (click)="clearSearch(); $event.stopPropagation()"
    />
    }
  </div>
  @if (showFilter) {
  <div class="filter-button" (click)="onFilterClick()">
    <img src="assets/icons/Filters.svg" alt="Filter" class="filter-svg-icon" />
    @if (hasActiveFilters) {
    <div class="filter-indicator"></div>
    }
  </div>
  }
</div>
